import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import axios from "../../axios";
import "./Login.css";
import Logo from "../../components/Logo/Logo";
import LoginSide from "../../components/LoginSide/LoginSide";
import ChangePasswordUI from "../../components/ChangePasswordUI/ChangePasswordUI";
import * as url from "../../utils/url";
import { isTrivvyProduct, TRIVIA_DESCRIPTION } from "../../utils/constants";
import { isMobile } from "../../utils/deviceInfo";

class SetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmPassword: {
        value: null,
        error: false,
      },
      password: {
        value: null,
        error: false,
      },
      errorMessage: "",
    };
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(this.props.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  submitUpdatedPassword = (password) => {
    // const params = new URLSearchParams(this.props.location.search);
    // const token = params.get('token');
    const token = this.getUrlParameter("token");

    axios
      .put(url.setPassword + token, { password: password })
      .then(() => {
        this.props.history.replace("/login");
      })
      .catch((error) => {
        this.setState({ ...this.state, errorMessage: error.response.data });
      });
  };

  render() {
    const fromTrivvy =
      isTrivvyProduct() || window.location.href.includes("fromTrivvy");
    return (
      <Container className="login-layout-container">
        <Row className="login-outer-wrapper">
          <div id="login-main" className="col-sm-10 col-md-10 col-lg-5">
            <div
              id="login-main-wrapper"
              className={`white-background ${fromTrivvy &&
                "forgot-pass-trivvy"}`}
            >
              {isTrivvyProduct() ? (
                <div className="text-center">
                  <span
                    className="sidebar-trivvy-logo-txt "
                    data-tip={TRIVIA_DESCRIPTION}
                  >
                    Trivvy
                  </span>
                </div>
              ) : (
                <Logo />
              )}
              <ChangePasswordUI
                title="Set Your Password"
                onSubmitPassword={this.submitUpdatedPassword}
                errorMessage={this.state.errorMessage}
              />
            </div>
          </div>
          {
            !isMobile && !fromTrivvy && <LoginSide />
          }
          
        </Row>
        <Row>
          <div id="login-secondary" className="col-sm-12 mb10 pl30">
            <div className="text-center">
              © {new Date().getFullYear()}{" "}
              {fromTrivvy ? (
                <a href="https://www.gotrivvy.com/">Trivvy</a>
              ) : (
                <a href="https://www.ouroffice.io/">OurOffice, Inc</a>
              )}
            </div>
          </div>
        </Row>
      </Container>
    );
  }
}

export default SetPassword;
